import vConsole from "vconsole";
import { useDarkMode } from "@ht/hooks/src/use-dark-mode";
import { setNavbarBackground } from "@ht/utils";

export const useDarkModePlugin = (vc: vConsole) => {
  const plugin = new vConsole.VConsolePlugin("darkmode_plugin", "深色模式");

  plugin.on("renderTab", render => {
    render(
      `<div style="line-height: 200px; text-align: center">点击下方按钮切换暗黑模式</div>`
    );
  });

  plugin.on("addTool", add => {
    add([
      {
        name: "切换暗黑模式",
        global: false,
        onClick: () => {
          // 切换暗黑模式
          const mode = useDarkMode();
          if (mode.isDarkMode) {
            mode.enable();
          } else {
            mode.disable();
          }
          try {
            if (mode.isDarkMode) {
              setNavbarBackground("#141414");
            } else {
              setNavbarBackground("#F7F7F7");
            }
          } catch {
            console.log("setNavbarBackground error: not in HT");
          }
          vc.hide();
        }
      }
    ]);
  });

  vc.addPlugin(plugin);
};
